import { render, staticRenderFns } from "./AdsCampaign.vue?vue&type=template&id=9779be04&scoped=true"
import script from "./AdsCampaign.vue?vue&type=script&lang=js"
export * from "./AdsCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9779be04",
  null
  
)

export default component.exports